import * as React from 'react';
import Slide from '@material-ui/core/Slide';
const ModalTransitionComponent = React.forwardRef((props, ref) => (React.createElement(Slide, Object.assign({ ref: ref }, props, { direction: "up", children: props.children }))));
export default ModalTransitionComponent;
